enum ActionType {
	request = 'MedicinalBrandsAnalytics.VirtualBrand.History.request',
	receive = 'MedicinalBrandsAnalytics.VirtualBrand.History.receive',
	prune = 'MedicinalBrandsAnalytics.VirtualBrand.History.prune',
}

export default ActionType;
